import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { Box } from '@twilio-paste/core/box'

import Buttons from './Buttons'
import Dropdown from './Dropdown'
import Calendar from './Calendar'

const defaultCurInteractives = { type: '' }

function Interactives({ manager, messageList, channelSid }) {
  const interactivesContainer = useRef(null)
  const [curInteractives, setCurInteractives] = useState(defaultCurInteractives)

  useEffect(() => {
    if (curInteractives !== defaultCurInteractives) {
      interactivesContainer.current.scrollIntoView()
    }
  }, [curInteractives])

  useEffect(() => {
    if (
      messageList.length > 0 &&
      !messageList[messageList.length - 1].isFromMe &&
      messageList[messageList.length - 1].source.state.attributes.interactiveWebchatOptions
    ) {
      const lastMessageAttributes =
        messageList[messageList.length - 1].source.state.attributes.interactiveWebchatOptions
      setCurInteractives(lastMessageAttributes)
    } else {
      setCurInteractives(defaultCurInteractives)
    }
  }, [messageList])

  const sendMessage = async (message) => {
    const curChannel = await manager.chatClient.getChannelBySid(channelSid)
    curChannel.sendMessage(message)
  }

  if (curInteractives === defaultCurInteractives) return <></>

  return (
    
    <Box ref={interactivesContainer} width='100%' paddingY='space40' paddingLeft='space100'>
      {curInteractives.type === 'buttons' ? (
        <Buttons curInteractives={curInteractives} sendMessage={sendMessage} />
      ) : curInteractives.type === 'dropdown' ? (
        <Dropdown curInteractives={curInteractives} sendMessage={sendMessage} />
      ) : curInteractives.type === 'calendar' ? (
        <Calendar curInteractives={curInteractives} sendMessage={sendMessage} />
      ) : (
        <></>
      )}
    </Box>
  )
}

const mapStateToProps = (state) => {
  return {
    messageList: state.flex.chat.channels[state.flex.session.channelSid].messages,
    channelSid: state.flex.session.channelSid,
  }
}

export default connect(mapStateToProps)(Interactives)
